<template>
  <div>

    <TheHeader/>

    <section class="layout">
      <div id="carousel">
        <img
            v-for="(photo, key) in item.photo"
            :key="key"
            width="425px"
            alt="Produkt."
            :src="getImageUrl(`product/small/${photo.file}`)"
        />
      </div>

      <div class="content">
        <h1>{{ item.name }}</h1>

        <div>{{ item.dimension }} cm</div>
        <div>{{ item.material }}</div>
        <div v-for="(note, key) in item.note" :key="key">
          {{ note }}
        </div>
        <div class="price">{{ item.price }} CZK</div>

        <div class="button">
          <a
              v-if="item.available"
              @click="addToCart"
              href="#"
              title="Koupit."
          >
            KOUPIT
          </a>
          <span v-if="!item.available">Vyprodáno &#128533;</span>

        </div>

      </div>
    </section>

    <TheFooter/>
  </div>
</template>

<script>
import TheFooter from "@/components/TheFooter.vue";
import TheHeader from "@/components/TheHeader";

export default {
  name: "Product",
  components: {
    TheHeader,
    TheFooter
  },
  data() {
    return {
      item: []
    }
  },
  props: ['id'],
  beforeCreate: function () {
    document.body.id = 'product';
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const apiUrl = "/data";
      fetch(`${apiUrl}/catalogue.json`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      })
          .then(response => response.json())
          .then(json => {
            console.log("API - catalogue.");

            // data definition
            let data = json;
            console.log(json);

            if (!data.error) {
                            this.item = data.data;

              let item = '';
              item = this.item.filter((row) => {
                console.log(`name: ${row.name}`);
                console.log(`available: ${row.available}`);

                // id comes from url as string
                // convert first to use ===
                if (row.id == this.id) {
                  return true;
                }
                return false;
              });
              this.item = item[0];
            }
            if (data.error) {
              console.log("Error.");
            }
          })
          .catch(error => {
            console.error("Error:", error);
          });
    },
    addToCart() {

      let localStorage = window.localStorage;

      let storeCart = localStorage.getItem('storeCart');

      if (storeCart) {
        console.log('storeCart is present');
        storeCart = JSON.parse(storeCart);
      } else {
        storeCart = [];
      }

      // type of variable
      console.log(typeof storeCart);

      // add product to array that will be later stored in localStorage
      storeCart.push(this.item.id.toString());

      console.log(storeCart);

      // get id of unique product in array
      let unique = storeCart.filter((currentValue, index, arr) => arr.indexOf(currentValue) === index);
      console.log(unique);

      // how many times is product in array
      console.log(storeCart.filter((currentValue) => currentValue == this.item.id).length);

      localStorage.setItem('storeCart', JSON.stringify(storeCart));
      console.log(localStorage);

      this.$router.push({
        name: 'cart'
      });
    }
  }
};
</script>
